export class LoggingLevel {
    public static None = 'None';
    public static Verbose = 'Verbose';
    public static Info = 'Info';
    public static Warning = 'Warning';
    public static Error = 'Error';
}
